
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { CarCard, Case, HumanCard } from '@/api';
import { CardTypesMap } from '@/store/application/data.assets';
import { CaseCardsData, loadDataModule } from '@/store/data/LoadDataModule';
import NButton from '@/uikit/buttons/NButton.vue';
import CardItemTile from '@/components/cards/CardItemTile.vue';
import SortDropdown from '@/components/common/SortDropdown.vue';
import DetectionDialog from '@/components/detection/DetectionDialog.vue';
import ObjectItem from '@/pages/cards/content/ObjectItem.vue';
import ExtendedCaseDescription from '@/pages/cases/common/ExtendedCaseDescription.vue';
import CameraShotAttach from '@/pages/users/uploader/CameraShotAttach.vue';
import { MultisidebarItemTypes } from '@/store/multisidebar/types';
import { multisidebarModule } from '@/store/multisidebar';
import { generateMultisidebarId } from '@/store/multisidebar/helpers';
import { DisplayType, DisplayTypes } from '@/store/application/page.definitions';

@Options({
  components: { CameraShotAttach, CardItemTile, DetectionDialog, ExtendedCaseDescription, NButton, ObjectItem, SortDropdown }
})
export default class CaseCardsView extends Vue {
  @Prop({ type: Array, required: false })
  readonly sortTypes?: any[] = [];

  @Prop({ type: Number, required: true })
  readonly cardId!: number;

  private caseCardsData: CaseCardsData | null = null;
  private loading: boolean = false;

  get multisidebarModule() {
    return multisidebarModule;
  }

  get pageSidebarType() {
    return MultisidebarItemTypes.CardsHumans;
  }

  getIsCardOpened(card: HumanCard | CarCard) {
    return this.multisidebarModule.currentItem?.id === generateMultisidebarId(this.pageSidebarType, card.id);
  }

  get cardType(): string {
    return CardTypesMap.Humans;
  }

  get displayType(): DisplayType {
    return DisplayTypes.Short;
  }

  @Watch('cardId')
  cardChangeHandler() {
    this.load();
  }

  async mounted() {
    await this.load();
  }

  async load() {
    this.caseCardsData = null;
    try {
      this.loading = true;
      this.caseCardsData = await loadDataModule.getLinkedCaseHumanCardsByCardID(this.cardId);
    } catch (e) {
      console.warn('case cards load error', e);
    } finally {
      this.loading = false;
    }
  }

  getTotalCards() {
    const result = this.caseCardsData?.cases?.reduce((m: number, v: Case) => { return m + this.getCaseCards(v.id).length; }, 0);
    return result;
  }

  getCaseCards(id: number): HumanCard[] {
    const participants = this.caseCardsData?.caseParticipants?.filter((v) => v.case === id);
    if (!participants) return [];
    const allCardsArray = participants.reduce<number[]>((m, v) => {
      if (Array.isArray(v.related_human_cards)) m = m.concat(v.related_human_cards.map((el) => el.id));
      return m;
    }, []);
    const cardsArray = Array.from(new Set(allCardsArray));
    return cardsArray
      .map((v) => this.caseCardsData?.caseCards.find((card) => card.id === v))
      .filter((v) => !!v)
      .filter((v) => v!.id != this.cardId) as HumanCard[];
  }

  actionHandler(name: string, card: HumanCard) {
    this.$emit('action', name, { item: card });
  }
}
